import React from "react";
import { Printer, Sparkles } from "lucide-react";

export default function FinishingPositioning() {
  return (
    <section
      data-testid="finishing-positioning-section"
      className="bg-white py-24 md:py-32 border-y border-slate-200"
    >
      <div className="max-w-7xl mx-auto px-6 md:px-12 lg:px-16">
        <div className="max-w-4xl mb-14">
          <div className="text-xs uppercase tracking-[0.2em] font-bold text-teal mb-4">
            The positioning
          </div>
          <h2
            data-testid="finishing-positioning-headline"
            className="font-serif text-3xl sm:text-4xl lg:text-5xl xl:text-6xl font-black tracking-tight text-navy leading-[1.1]"
          >
            This Is What Separates Schools That{" "}
            <span className="text-slate-400">Print</span>…
            <br />
            <span className="text-teal">from Schools That Produce.</span>
          </h2>
        </div>

        <div className="grid md:grid-cols-2 gap-6 lg:gap-8">
          <div className="bg-[#F4F6F4] border border-slate-200 rounded-2xl p-8 lg:p-10">
            <div className="w-12 h-12 rounded-lg bg-slate-200 text-slate-500 flex items-center justify-center mb-5">
              <Printer className="w-6 h-6" strokeWidth={2} />
            </div>
            <span className="text-[11px] uppercase tracking-[0.18em] font-bold text-slate-500 mb-2 block">
              Print only
            </span>
            <h3 className="font-serif text-2xl font-bold text-slate-700 mb-3">
              Anyone can print.
            </h3>
            <p className="text-slate-600 leading-relaxed">
              The output is fine. But finishing happens elsewhere—or not at all—
              and it shows in how the campus actually looks.
            </p>
          </div>

          <div className="relative bg-navy text-white border border-teal/30 rounded-2xl p-8 lg:p-10 shadow-xl overflow-hidden">
            <div className="cmyk-ribbon h-[3px] w-full absolute top-0 left-0 right-0" aria-hidden />
            <div className="w-12 h-12 rounded-lg bg-teal text-white flex items-center justify-center mb-5">
              <Sparkles className="w-6 h-6" strokeWidth={2} />
            </div>
            <span className="text-[11px] uppercase tracking-[0.18em] font-bold text-teal mb-2 block">
              Print + finish
            </span>
            <h3 className="font-serif text-2xl font-bold text-white mb-3">
              Schools with the right tools produce.
            </h3>
            <p className="text-slate-200 leading-relaxed">
              Better visuals, faster turnaround, a campus that looks and feels
              professional—because the whole pipeline lives in-house.
            </p>
          </div>
        </div>
      </div>
    </section>
  );
}
